/**
 * Audio Preset Configurations for Voice Echo Studio
 */
export const PRESETS = {
  commentary: {
    id: "commentary",
    name: "Stage Commentary",
    description: "Clear speech with short slapback delay for live announcement clarity.",
    delayTime: 150, // ms
    feedback: 0.25, // ~3 repeats
    repeats: 3,
    echoVolume: 0.35,
    dryWetMix: 25, // 25% wet, 75% dry
    masterVolume: 0.9,
    stereoPan: 0,
    noiseReduction: true,
    compressor: true,
    reverb: false,
    reverbVolume: 0,
    eqLow: 2, // slightly boost bass for warmth
    eqMid: 0,
    eqHigh: 4, // boost speech presence
  },
  temple: {
    id: "temple",
    name: "Temple Announcement",
    description: "Atmospheric, ambient decay typical of spacious temple or worship corridors.",
    delayTime: 380, // ms
    feedback: 0.62, // ~9 repeats
    repeats: 9,
    echoVolume: 0.5,
    dryWetMix: 40,
    masterVolume: 0.85,
    stereoPan: 0,
    noiseReduction: false,
    compressor: true,
    reverb: true,
    reverbVolume: 0.55, // thick reverb
    eqLow: 0,
    eqMid: -2,
    eqHigh: 2,
  },
  dj: {
    id: "dj",
    name: "DJ Studio Voice",
    description: "Deep, punchy sound with rhythmic echoes and bass boosts for club hosting.",
    delayTime: 180, // ms
    feedback: 0.5, // ~6 repeats
    repeats: 6,
    echoVolume: 0.6,
    dryWetMix: 45,
    masterVolume: 0.8,
    stereoPan: -0.1, // slightly panned left
    noiseReduction: false,
    compressor: true,
    reverb: true,
    reverbVolume: 0.25,
    eqLow: 6, // strong bass boost
    eqMid: 1,
    eqHigh: 3,
  },
  karaoke: {
    id: "karaoke",
    name: "Karaoke Reverb",
    description: "Classic karaoke setup with soft double delays and lush space to flatter vocals.",
    delayTime: 220, // ms
    feedback: 0.35, // ~4 repeats
    repeats: 4,
    echoVolume: 0.45,
    dryWetMix: 33,
    masterVolume: 0.85,
    stereoPan: 0.1, // slightly panned right
    noiseReduction: false,
    compressor: true,
    reverb: true,
    reverbVolume: 0.4,
    eqLow: 2,
    eqMid: 2,
    eqHigh: 3,
  },
  concert: {
    id: "concert",
    name: "Concert Hall",
    description: "Grand stadium decay, long spacing echo loops, and high density room reverberation.",
    delayTime: 480, // ms
    feedback: 0.7, // ~10 repeats
    repeats: 10,
    echoVolume: 0.65,
    dryWetMix: 50,
    masterVolume: 0.8,
    stereoPan: 0,
    noiseReduction: false,
    compressor: true,
    reverb: true,
    reverbVolume: 0.65,
    eqLow: 3,
    eqMid: -1,
    eqHigh: 5,
  },
  speech: {
    id: "speech",
    name: "Dry Speech Focus",
    description: "Maximum voice clarity, no echo or reverb. Eliminates hums and optimizes vocals.",
    delayTime: 0, // ms (bypassed)
    feedback: 0,
    repeats: 1,
    echoVolume: 0,
    dryWetMix: 0, // 100% dry
    masterVolume: 0.95,
    stereoPan: 0,
    noiseReduction: true,
    compressor: true,
    reverb: false,
    reverbVolume: 0,
    eqLow: -4, // cut low frequency muddy rumble
    eqMid: 3,  // boost vocal mid frequencies
    eqHigh: 3,  // crisp definition
  },
  podcast: {
    id: "podcast",
    name: "Warm Podcast",
    description: "Warm, intimate broadcast tone with rich lows, high shelf, and minimal room space.",
    delayTime: 40, // ultra short delay for double tracking effect
    feedback: 0.08,
    repeats: 1,
    echoVolume: 0.15,
    dryWetMix: 15,
    masterVolume: 0.9,
    stereoPan: 0,
    noiseReduction: true,
    compressor: true,
    reverb: true,
    reverbVolume: 0.08, // micro-reverb room size
    eqLow: 4,  // heavy low warm depth
    eqMid: 1,
    eqHigh: 4,  // high end sizzle
  }
};

export const DEFAULT_PARAMS = {
  isMuted: false,
  delayTime: 250,
  feedback: 0.45,
  repeats: 5,
  echoVolume: 0.5,
  dryWetMix: 50,
  masterVolume: 0.8,
  musicVolume: 0.5, // Backing track volume default
  stereoPan: 0,
  noiseReduction: true,
  compressor: false,
  reverb: false,
  reverbVolume: 0.3,
  eqLow: 0,
  eqMid: 0,
  eqHigh: 0,
};
